import type { SxProps } from "@mui/material";

export const miniBarPosStyle = {
  position: "sticky",
  top: 24,
  right: 0,
  zIndex: 5,
};

export const miniBarStyle: SxProps = {
  position: "absolute",
  display: "flex",
  top: -24,
  right: 20,
  height: 45,
  alignItems: "center",
  borderRight: "1px solid rgba(0, 0, 0, 0.12)",
  borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
  borderLeft: "1px solid rgba(0, 0, 0, 0.12)",
  borderRadius: "0 0 15px 15px",
  background: "var(--bg-color)",
};

export const itemsStyle: SxProps = {
  paddingTop: 1.5,
};
